import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay, finalize, switchMap } from 'rxjs/operators';

@Injectable()
export class RequestDelayInterceptor implements HttpInterceptor {
  private readonly ongoingRequests = new Map<string, number>();
  private readonly DELAY_TIME_MS = 250; // 150 ms delay

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const endpoint = req.url;
    console.log("🚀 ~ RequestDelayInterceptor ~ endpoint:", endpoint)

    if (this.ongoingRequests.has(endpoint)) {
      const requestCount = this.ongoingRequests.get(endpoint)!;
      this.ongoingRequests.set(endpoint, requestCount + 1);

      return of(null).pipe(
        delay(this.DELAY_TIME_MS * requestCount),
        switchMap(() => this.handleRequest(req, next, endpoint))
      );
    }

    this.ongoingRequests.set(endpoint, 1);
    return this.handleRequest(req, next, endpoint);
  }

  private handleRequest(
    req: HttpRequest<any>,
    next: HttpHandler,
    endpoint: string
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      finalize(() => {
        const requestCount = this.ongoingRequests.get(endpoint);
        if (requestCount) {
          if (requestCount > 1) {
            this.ongoingRequests.set(endpoint, requestCount - 1);
          } else {
            this.ongoingRequests.delete(endpoint);
          }
        }
      })
    );
  }
}